const languages = [
    { name: "Svenska", code: "sv" },
    { name: "English", code: "en", isDefault: true }
];

export default languages;

